import styled from 'styled-components';

const ContentContainer = styled.div`
  padding-bottom: ${props => props.theme.space.single};
  max-width: 960px;
  min-height: 100vh;
  margin: auto;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export default ContentContainer;
